import { css, html, LitElement, type TemplateResult } from "lit";
import { customElement } from "lit/decorators.js";
import { base } from "../../design-system/index.ts";
import "./home-shader.ts";

const styles = css`
  :host {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

@customElement("home-view")
export class HomeViewElement extends LitElement {
  static override styles = [base, styles];

  override render(): TemplateResult {
    return html`<home-shader></home-shader>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "home-view": HomeViewElement;
  }
}
